module.exports = __webpack_public_path__ + "img/icon_laft.b0bb6337.png";